import { render, staticRenderFns } from "./setfc.vue?vue&type=template&id=54f043b6&scoped=true&"
import script from "./setfc.vue?vue&type=script&lang=js&"
export * from "./setfc.vue?vue&type=script&lang=js&"
import style0 from "./setfc.vue?vue&type=style&index=0&id=54f043b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f043b6",
  null
  
)

export default component.exports